import React, { useRef } from 'react';
import "./Hand.css";
import Draggable from 'react-draggable'

function Hand(props) {

    var EO = false;
    var renderFor450 = window.screen.width <= 450;
    const handBarRef = useRef(null);

    var fixedOffset;

    if (renderFor450)
    {
        fixedOffset = 25;
    }
    else
    {
        fixedOffset = 50;
    }

    const createCard = (card, offset) => {
        let nodeRef = React.createRef();
        return <Draggable key = {`${card}-${offset}`} nodeRef = {nodeRef} onStop = {() => DragHandlerLate(nodeRef, offset)}><img ref = {nodeRef} src = {process.env.PUBLIC_URL + card + ".png"} className = "cardMine" alt = "king1" style = {{left: offset*fixedOffset, transform: "translate(0,0)"}}/></Draggable>
    }

    const mapCards = (handArray) => {
        let offsets = [];
        for (let i = 0; i < handArray.length; i++) {
            offsets[i] = 1;
        } 
        let mappedHand = handArray.map(createCard, offsets);
        return mappedHand
    }

    const DragHandlerLate = (ref, pos1) => {
        setTimeout(DragHandler, 1, ref, pos1);
    }
    

    var HandRender = mapCards(props.hand);

    const playAttempt = (pos) => {
        props.playCard(pos)
    }

    const discAttempt = (pos) => {
        props.discAttempt(pos)
        EO = true
    }

    const isDroppedOnTarget = (cardNode, targetRef, margin = 16) => {
        const targetNode = targetRef?.current;
        if (!cardNode || !targetNode) {
            return false;
        }
        const cardRect = cardNode.getBoundingClientRect();
        const targetRect = targetNode.getBoundingClientRect();
        const cardCenterX = cardRect.left + (cardRect.width / 2);
        const cardCenterY = cardRect.top + (cardRect.height / 2);
        return (
            cardCenterX >= targetRect.left - margin &&
            cardCenterX <= targetRect.right + margin &&
            cardCenterY >= targetRect.top - margin &&
            cardCenterY <= targetRect.bottom + margin
        );
    }

    const reorderWithinHand = (cardNode, pos1) => {
        const barNode = handBarRef.current;
        if (!barNode) {
            props.editOrder(pos1, pos1)
            return;
        }
        const barRect = barNode.getBoundingClientRect();
        const cardRect = cardNode.getBoundingClientRect();
        const cardCenterX = cardRect.left + (cardRect.width / 2);
        const relativeCenter = cardCenterX - barRect.left;
        let pos2 = Math.floor(relativeCenter / fixedOffset);
        pos2 = Math.max(0, Math.min(pos2, props.hand.length - 1));
        pos1 = Math.max(0, Math.min(pos1, props.hand.length - 1));
        EO = true
        props.editOrder(pos1, pos2)
    }

    const DragHandler = (ref, pos1) => { 
        if (!EO)
        {
            const cardNode = ref.current;
            if (!cardNode) {
                return;
            }

            if (props.playCycleFlag && parseInt(props.myspot, 10) === props.waitingOn2Play && isDroppedOnTarget(cardNode, props.playTargetRef, renderFor450 ? 12 : 20))
            {
                playAttempt(pos1)
            }
            else if ((props.discCycle || props.fca) && isDroppedOnTarget(cardNode, props.discardTargetRef, renderFor450 ? 18 : 24))
            {
                discAttempt(pos1)
            }
            else
            {
                reorderWithinHand(cardNode, pos1)
            }
        }
    }

    return (
        <main>
            <div className = 'cardBarMine' ref = {handBarRef}>
                {/* <img src = {this.props.hand[0]} className = "card" alt = "king1" 
                                    style={{left: 50}}/>
                <img src = {this.props.hand[1]} className = "card" alt = "king1" 
                                    style={{left: 100}}/>
                <img src = {this.props.hand[2]} className = "card" alt = "king1" 
                                    style={{left: 150}}/>
                <img src = {this.props.hand[3]} className = "card" alt = "king1" 
                                    style={{left: 200}}/>
                <img src = {this.props.hand[4]} className = "card" alt = "king1" 
                                    style={{left: 250}}/>
                <img src = {this.props.hand[5]} className = "card" alt = "king1" 
                                    style={{left: 300}}/>
                <img src = {this.props.hand[6]} className = "card" alt = "king1" 
                                    style={{left: 350}}/>
                <img src = {this.props.hand[7]} className = "card" alt = "king1" 
                                    style={{left: 400}}/>
                <img src = {this.props.hand[8]} className = "card" alt = "king1" 
                                    style={{left: 450}}/> */}

                {HandRender}
            </div>
        </main>
    );
};

export default Hand
